import React, { useState } from "react";
import { BiCog, BiEnvelope, BiPhone } from "react-icons/bi";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { FooterData } from "./data";
import { IoSettingsSharp } from "react-icons/io5";
import SelectLanguage from "../SelectLanguage/SelectLanguage";
import "./footer.scss";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
  FaMobileAlt,
  FaBehance
} from "react-icons/fa";
import ColorSwitch from "./ColorSwitch";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import {
  BsEnvelope,
  BsFillTelephoneFill,
  BsFillTelephonePlusFill,
} from "react-icons/bs";
import ThemeSwitcher from "./ThemeSwitcher";

import { AiOutlinePhone } from "react-icons/ai";
import { GoLocation } from "react-icons/go";
import Logo from "../Nav/Logo/Logo";
import { ReactComponent as LogoIcon } from "../../../assets/shared/logo.svg";

const Footer = (props) => {
  const [email, setEmail] = useState("");
  const [mode, setMode] = useState(() => localStorage.getItem("mode"));

  return (
    <div className="shared-footer">
      <div className="first-row">
        <div className="left">
          <div className="logo">
            <Logo logo={<LogoIcon />} stickyColors />
          </div>
        </div>

        <div className="right">
          <div className="social">
            <a target="_blank" href="https://www.facebook.com/ylliriagency">
              <FaFacebookF />
            </a>
            <a target="_blank" href="https://www.instagram.com/ylliricom/?igshid=MzRlODBiNWFlZA%3D%3D&fbclid=IwAR1Tp2u2KNNoXevcZOtEF66u_1E7J6WHbKiBM5168BzVpdgCU10ef7fgvkk">
              <FaInstagram />
            </a>
            <a target="_blank" href="https://www.linkedin.com">
              <FaLinkedinIn />
            </a>
            <a target="_blank" href="https://twitter.com">
              <FaTwitter />
            </a>
            <a target="_blank" href="https://www.behance.net/">
              <FaBehance />
            </a>
          </div>
        </div>
      </div>

      <div className="second-row">
        <div className="all-footer-links">
          {FooterData.map((props, i) => {
            return (
              <div key={i} className="footer-list">
                <h6>{props.category}</h6>
                <div className="links">
                  {props.links.map((l, k) => {
                    return (
                      <Link key={k} to={l.to} className="def-text footer-item">
                        {l.link}
                      </Link>
                    );
                  })}
                </div>
              </div>
            );
          })}

          <div className="footer-list last-col">
            <h6>
              <FormattedMessage id="Reachout" defaultMessage="Reach Out" />
            </h6>
            <div className="links">
              <div className="row">
                <div className="icon">
                  <BiEnvelope />
                </div>
                <p className="def-text">info@ylliri.com</p>
              </div>
              <div className="row">
                <div className="icon">
                  <BsFillTelephonePlusFill />
                </div>
                <p className="def-text">+383 45 111 222</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="last-row">
        <div className="left">
          <p className="def-text">
            <FormattedMessage id="footer-p2" defaultMessage="© 2022 Ylliri" />
          </p>
        </div>

        <div className="links">
          <Link to="/">
            <FormattedMessage
              id="privacy-policy"
              defaultMessage="Privacy Policy"
            />
          </Link>
          <div className="line"></div>
          <Link to="/">
            <FormattedMessage id="cookies" defaultMessage="Cookies" />
          </Link>
        </div>

        <SelectLanguage
          setLanguage={props.setLanguage}
          language={props.language}
        />
      </div>
    </div>
  );
};

export default Footer;
